var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @jsx h */

import { createImageUrl } from '@nrk/serum-imagecrop-utils';
import { h } from 'preact';
import PureComponent from '../../lib/preact-pure-component';

var SerumImage = function (_PureComponent) {
  _inherits(SerumImage, _PureComponent);

  function SerumImage() {
    _classCallCheck(this, SerumImage);

    return _possibleConstructorReturn(this, (SerumImage.__proto__ || Object.getPrototypeOf(SerumImage)).apply(this, arguments));
  }

  _createClass(SerumImage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          alt = _props.alt,
          id = _props.id,
          quality = _props.quality,
          ratio = _props.ratio,
          width = _props.width;


      var src = createImageUrl({
        id: id,
        width: width,
        quality: quality,
        ratio: ratio
      });

      return h('img', { className: className, src: src, alt: alt });
    }
  }]);

  return SerumImage;
}(PureComponent);

export default SerumImage;